var React = require('react');

function IconVideoInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Page-1","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd"},React.createElement("path",{"d":"M32.5,0 C50.4492544,0 65,14.5507456 65,32.5 C65,50.4492544 50.4492544,65 32.5,65 C14.5507456,65 0,50.4492544 0,32.5 C0,14.5507456 14.5507456,0 32.5,0 Z M23,20 L23,48 L51,34 L23,20 Z","id":"Combined-Shape","fill":"currentColor","fillRule":"nonzero"})));
}

IconVideoInline.defaultProps = {"width":"65px","height":"65px","viewBox":"0 0 65 65","version":"1.1"};

module.exports = IconVideoInline;

IconVideoInline.default = IconVideoInline;
